import { useState, useContext, useEffect } from "react"
import { gql, useLazyQuery } from "@apollo/client"
import { LoaderMedium } from "../../Loaders"
import { useParams } from "react-router-dom"

import _ from "lodash"

import { Field, useFormikContext } from "formik"

import { Checkbox } from "primereact/checkbox"
import { FormContext } from "../../../context/formContext"
import { UserContext } from "../../../context/userContext"

import styles from "../../../styles/Form.module.css"

export default function CheckboxOrganizationMicroservices({
  field,
  block,
  index,
}) {
  const { idStamp } = useParams()
  const [microserviceList, setMicroserviceList] = useState([])
  const formik = useFormikContext()
  const form = useContext(FormContext)
  const userCtx = useContext(UserContext)
  const isDisabled = field.read_only || (form ? form.blocksSaved[block] : false)

  const GET_MICROSERVICES = gql`
    query getMicroservices(
      $staff_id: ID!
      $staff_organization_id: ID!
      $staff_enterprise_id: ID!
      $organization_stamp_id: ID!
    ) {
      microservices: getAllMicroservicesByOrganizationStampId(
        staff_id: $staff_id
        staff_organization_id: $staff_organization_id
        staff_enterprise_id: $staff_enterprise_id
        organization_stamp_id: $organization_stamp_id
      ) {
        microservices_id
        microservices_name
        microservices_alias
        microservices_description
        microservices_fee_amount
        microservices_authorized
      }
    }
  `

  const [getMicroservices, { loading, error }] = useLazyQuery(
    GET_MICROSERVICES,
    {
      fetchPolicy: "no-cache",
      onCompleted: ({ microservices }) => {
        setMicroserviceList(microservices)
      },
      skip: !userCtx,
    }
  )

  useEffect(() => {
    if (userCtx) {
      getMicroservices({
        variables: {
          staff_id: userCtx.session.user.staff_id,
          staff_organization_id: userCtx.session.user.organization_id,
          staff_enterprise_id: userCtx.session.user.enterprise_id,
          organization_stamp_id: idStamp || "",
        },
      })
    }
  }, [userCtx, idStamp, getMicroservices])

  useEffect(() => {
    const unauthorizedFields = {}
    microserviceList.forEach((microservice) => {
      const field_name = `microservice_${_.replace(
        _.lowerCase(microservice.microservices_name),
        / /g,
        "_"
      )}`
      if (microservice.microservices_authorized === "0") {
        unauthorizedFields[field_name] = []
      }
    })
    formik.resetForm({
      values: {
        ...formik.values,
        ...unauthorizedFields,
      },
    })
  }, [microserviceList])

  if (loading) {
    return (
      <div>
        <LoaderMedium />
      </div>
    )
  }

  if (error) {
    return (
      <div>
        <p>Error loading microservices.</p>
      </div>
    )
  }

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: "block",
      }}
    >
      {microserviceList && microserviceList.length > 0 ? (
        microserviceList.map((microservice, index) => {
          const field_name = `microservice_${_.replace(
            _.lowerCase(microservice.microservices_name),
            / /g,
            "_"
          )}`

          if (microservice.microservices_authorized === "0") {
            return (
              <Field name={field_name} key={index}>
                {({ field: formikField }) => (
                  <input
                    type="hidden"
                    name={field_name}
                    value={formikField.value}
                  />
                )}
              </Field>
            )
          }

          return (
            <div key={index} onBlur={() => formik.setFieldTouched(field_name)}>
              <Field name={field_name}>
                {({ field: formikField }) => (
                  <div
                    className={styles.field}
                    style={{
                      order: index,
                      display: "block",
                    }}
                  >
                    <Checkbox
                      disabled={isDisabled}
                      inputId={field_name}
                      name={field_name}
                      id={field_name}
                      value={microservice.microservices_id}
                      onChange={formikField.onChange}
                      checked={_.includes(
                        formikField.value,
                        microservice.microservices_id
                      )}
                    />
                    <label
                      htmlFor={field_name}
                      style={{ marginLeft: 5, fontWeight: "bold" }}
                    >
                      {microservice.microservices_alias}
                    </label>
                    {microservice.microservices_description && (
                      <div
                        className={styles.description}
                        dangerouslySetInnerHTML={{
                          __html: microservice.microservices_description,
                        }}
                      />
                    )}
                    {microservice.microservices_fee_amount && (
                      <p
                        style={{ marginLeft: 5, fontStyle: "italic" }}
                        className={styles.description}
                      >
                        {microservice.microservices_fee_amount}
                      </p>
                    )}
                  </div>
                )}
              </Field>
            </div>
          )
        })
      ) : (
        <div className={styles.noServices}>
          <p>
            There are no services available for the organization at this moment.
            Please consult your administrator for further assistance.
          </p>
        </div>
      )}
    </div>
  )
}
